import React, { useState } from "react";
import List from "components/list";
import { useParams } from "react-router-dom";
import { StatusCell } from "@/components/status/cell";
import { DateCell } from "@/components/date/cell";
import { EmployeeUserCell } from "components/cell/employee/cell";
import JobNameCell from "@/components/cells/jobs/name-cell";
import { getdirectusUserFields } from "components/user/config";
import ProjectSurveyCardSection from "./card-section";
import PerformanceDetailsSidebar from "@/modules/performance/overview/components/performance-details-sidebar";
import { useProject } from "../context";

export default function ProjectSurveys() {

    const { id } = useProject()
    const [selectedCard, setSelectedCard] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleCardClick = (cardData) => {
        setSelectedCard(cardData);
        setIsSidebarOpen(true);
    };

    const handleCloseSidebar = () => {
        setIsSidebarOpen(false);
        setSelectedCard(null);
    };

    const columns = [
        {
            id: "title",
            header: "Title",
            accessorKey: "title",
        },
        {
            id: "job",
            header: "Job",
            accessorKey: "job.name",
            cell: JobNameCell,
        },
        {
            id: "status",
            header: "Status",
            accessorKey: "status",
            cell: StatusCell,
        },
        {
            id: "date_created",
            header: "Created on",
            accessorKey: "date_created",
            cell: DateCell,
        },
        {
            id: "user_created",
            header: "Created by",
            accessorKey: "user_created",
            cell: EmployeeUserCell,
        },
        {
            id: "date_updated",
            header: "Submitted On",
            accessorKey: "date_updated",
            cell: DateCell,
        },
        {
            id: "user_updated",
            header: "Submitted by",
            accessorKey: "user_updated",
            cell: EmployeeUserCell,
        },
    ];

    const fields = [
        "id",
        "status",
        "title",
        "job.id",
        "job.name",
        "date_created",
        "date_updated",
        getdirectusUserFields("user_created"),
        getdirectusUserFields("user_updated"),
    ];

    const filters = {
        job: {
            project: {

                _eq: id,

            },
        },
    };
    if (!id) return null

    return (
        <div className="flex-1 w-full">
            <ProjectSurveyCardSection onClick={handleCardClick} />
            <List
                title="Surveys"
                endPoint="surveys"
                storageKey={`survey-${id}`}
                showSearch={false}
                filters={filters}
                columns={columns}
                meta={{ fields }}
                href={(item) => `/work/jobs/${item.job.id}/surveys/${item.id}`}
            />
            <PerformanceDetailsSidebar
                isOpen={isSidebarOpen}
                onClose={handleCloseSidebar}
                cardData={selectedCard}
            />
        </div>
    );
}
